import React from "react";
import { Icon } from "antd";

import { addOneMonth, removeOneMonth } from "../../../utils/date.utils";
import moment from "moment";

export const SelectMonth = ({ setRangeDate, rangeDate }) => (
  <div className="flex items-center m-5 justify-center">
    <button
      className="rounded-full h-10 w-10 flex items-center justify-center"
      style={{ outline: "none" }}
      onClick={() => {
        setRangeDate(removeOneMonth(rangeDate));
      }}
    >
      <Icon type="left" />
    </button>
    <div style={{ fontSize: 30 }}>{`${rangeDate[0].format("MMMM YYYY")}`}</div>
    {rangeDate[0].format("MMMM YYYY") !== moment().format("MMMM YYYY") && (
      <button
        className="rounded-full h-10 w-10 flex items-center justify-center"
        style={{ outline: "none" }}
        onClick={() => {
          setRangeDate(addOneMonth(rangeDate));
        }}
      >
        <Icon type="right" />
      </button>
    )}
  </div>
);



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/Accounting/components/SelectMonth.component.js